export const isButtonDisabledCoordinador = (persmiso, rol, direcciones) => {
  if (persmiso !== "1") {
    return true;
  }
  if (rol === "Coordinador" && direcciones.length === 0) {
    return true;
  }
  return false;
};
